import React from 'react';
import {
    PropsShell,
    PropsNotFound,
    PropsCommonFields,
    PropsSection,
    PropsField,
    PropsRequiredAndMeta,
    useQuestionProperties,
} from './QuestionPropertiesShared';

const TextAreaBlockProperties = ({ questionId }) => {
    const { question, localName, nameError, handleUpdate, handleNameChange } =
        useQuestionProperties(questionId);

    if (!question) return <PropsNotFound />;

    return (
        <PropsShell typeLabel="Multi-line text" typeIcon="bi-textarea-t">
            <PropsCommonFields
                localName={localName}
                nameError={nameError}
                onNameChange={handleNameChange}
                title={question.title}
                description={question.description}
                onTitleChange={(value) => handleUpdate('title', value)}
                onDescriptionChange={(value) => handleUpdate('description', value)}
            />

            <PropsSection title="Input">
                <PropsField label="Placeholder">
                    <input
                        type="text"
                        className="form-control form-control-sm"
                        value={question.placeholder || ''}
                        onChange={(e) => handleUpdate('placeholder', e.target.value)}
                    />
                </PropsField>
                <div className="ecx-survey-props__row">
                    <PropsField label="Rows">
                        <input
                            type="number"
                            className="form-control form-control-sm"
                            min={1}
                            max={20}
                            value={question.rows || 4}
                            onChange={(e) =>
                                handleUpdate('rows', parseInt(e.target.value, 10) || 4)
                            }
                        />
                    </PropsField>
                    <PropsField label="Max length" hint="Leave empty for no limit">
                        <input
                            type="number"
                            className="form-control form-control-sm"
                            value={question.maxLength || ''}
                            onChange={(e) =>
                                handleUpdate(
                                    'maxLength',
                                    e.target.value ? parseInt(e.target.value, 10) : null
                                )
                            }
                        />
                    </PropsField>
                </div>
            </PropsSection>

            <PropsRequiredAndMeta
                required={question.required}
                onRequiredChange={(value) => handleUpdate('required', value)}
                questionId={questionId}
            />
        </PropsShell>
    );
};

export default TextAreaBlockProperties;
